import React from "react";
import { Modal, List } from "antd";
import { Link } from "react-router-dom";

const res = {
  details: [
    {
      meterId: "3345678987302",
      status: "success",
    },
    {
      meterId: "3345678987301",
      status: "success",
    },
  ],
  totalMeters: 2,
  successCount: 2,
  failureCount: 0,
};

const TriggerResult = ({ response, open, setOpen }) => {
  return (
    <Modal
      title="Command results"
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <p>Total Meters: {response?.totalMeters ?? 0}</p>
      <p>Success Count: {response?.successCount ?? 0}</p>
      <p>Failure Count: {response?.failureCount ?? 0}</p>

      <List
        header={<strong>Meter Details</strong>}
        bordered={false}
        dataSource={response?.details ?? []}
        renderItem={(item) => (
          <List.Item className="flex justify-between">
            <div className="">
              <strong>Meter ID:</strong>
              <Link to={"/"} className="text-black underline ">
                {item?.meterId ?? ""}
              </Link>
            </div>
            <div
              className={`${
                item.status === "success" ? "bg-green-100" : "bg-red-100"
              } rounded-full p-[5px] text-xs`}
            >
              {item.status === "success" ? "Request sent" : "Request failed"}
            </div>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default TriggerResult;
